import { styled, Paper, Typography } from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const notification = {
  Container: styled(Paper)(({ theme }) => ({
    padding: '12px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'start',
    width: '100%',
    height: '48px',
    '& svg': {
      marginRight: '12px',
    },
    [theme.breakpoints.down('desktop')]: {
      height: '75px',
    },
  })),
  Text: styled(Typography)(({ theme }) => ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    fontSize: pxToRem(16),
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': '1',
    [theme.breakpoints.down('desktop')]: {
      '-webkit-line-clamp': '2',
    },
  })),
};
